import React, { useState } from 'react';

// ==========================================
// 1. 开关组件样式 (添加到你的 popupStyles 中，或者单独新建一个)
// ==========================================
const switchStyles = `
  .custom-toggle-switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 40px;
    height: 22px;
    border-radius: 11px;
    background-color: #e2e8f0;
    cursor: pointer;
    transition: background-color 0.3s ease;
    /* 防御性样式：防止被父级 Flex 拉伸或压缩 */
    flex-shrink: 0;
    align-self: center;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    border: none;
    outline: none;
  }

  .custom-toggle-switch.is-on {
    background-color: #00b5ad; /* 你的主题青色 */
  }

  .custom-toggle-switch:hover {
    box-shadow: 0 0 0 3px rgba(0, 181, 173, 0.15);
  }

  .custom-toggle-switch.is-on:hover {
    box-shadow: 0 0 0 3px rgba(0, 181, 173, 0.25);
  }

  /* 圆形滑块 */
  .custom-toggle-thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 18px;
    height: 18px;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1), width 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  /* 开启时，滑块向右移动 */
  .custom-toggle-switch.is-on .custom-toggle-thumb {
    transform: translateX(18px);
  }

  /* 开启时，滑块上显示一个小勾 */
  .custom-toggle-switch.is-on .custom-toggle-thumb::after {
    content: '';
    display: block;
    width: 4px;
    height: 7px;
    border: solid #00b5ad;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-top: -2px;
  }

  /* 交互微调：按下时滑块变长一点，松手恢复 */
  .custom-toggle-switch:active .custom-toggle-thumb {
    width: 20px;
  }
  .custom-toggle-switch.is-on:active .custom-toggle-thumb {
    transform: translateX(16px);
    width: 20px;
  }
`;

// ==========================================
// 2. 独立的开关组件 ToggleSwitch
// ==========================================
interface ToggleSwitchProps {
  /** 是否开启 */
  checked: boolean;
  /** 状态改变时的回调 */
  onChange: (checked: boolean) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange }) => {
  return (
    <>
      <style>{switchStyles}</style>
      <div
        className={`custom-toggle-switch ${checked ? 'is-on' : ''}`}
        onClick={() => onChange(!checked)}
        role="switch"
        aria-checked={checked}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onChange(!checked);
          }
        }}
      >
        <div className="custom-toggle-thumb" />
      </div>
    </>
  );
};

export default ToggleSwitch;